import { Core } from "@faire/design-tokens";
import { isAndroid, isIOS } from "@faire/help-center-utils/lib/isMobileApp";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { isAndroidChatEnabled, isIOsChatEnabled } from "../../utils/isMobileChatEnabled";
export var LiveChatUnavailable = function LiveChatUnavailable() {
  if (isIOS() && !isIOsChatEnabled() || isAndroid() && !isAndroidChatEnabled()) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
      width: "2x"
    }), /*#__PURE__*/React.createElement(Typography, {
      variant: "labelSansRegular",
      color: Core.text.subdued
    }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "YjqSzB",
      defaultMessage: [{
        "type": 0,
        "value": "O chat em direto está disponível em inglês num computador."
      }]
    })));
  }
  return null;
};